import useInvalidateShop from "./use-invalidate-shop.ts";
import { useInvalidateAllShopEmailTemplates } from "./use-get-all-shop-email-templates.ts";
import { useApiMutation } from "./use-api-mutation";

export default function useDeleteEmailTemplate(shopId: string) {
	return useApiMutation(
		"delete",
		"/shops/{shopId}/email-templates/{templateId}",
		{
			invalidate: [
				useInvalidateShop(shopId),
				useInvalidateAllShopEmailTemplates(shopId),
			],
			mapVariables: (templateId: string) => ({
				params: { path: { shopId, templateId } },
			}),
		},
	);
}
